<template>
  <li>
    <span
      class="bto-sb-sportlist-menu-item"
      v-if="!sportMatchesSorted[index - 1] || sportMatchesSorted[index].tournamentId !== sportMatchesSorted[index - 1].tournamentId"
    >
      <span class="bto-sb-sportlist-menu-category-name">{{sportMatchesSorted[index].tournamentName}}</span>
      <span class="bto-sb-sportlist-menu-category-events" v-show="false">X</span>
    </span>
    <ul class="bto-sb-sportlist-menu-level-3">
      <li
        :class="{'bto-sb-sportlist-menu-item-active' : sportMatchesSorted[index].betRadarId == matchSelectedId}"
      >
      <span class="bto-sb-sportlist-menu-item">
        <a href="javascript:void(0);" @click="liveMatchClick(sportMatchesSorted[index])">
          <span class="bto-sb-sportlist-menu-tournament-name">{{sportMatchesSorted[index].homeTeam}} {{t('Mobile.VS')}} {{sportMatchesSorted[index].guestTeam}}</span>
          <span class="bto-sb-sportlist-menu-tournament-match-live">
            {{sportMatchesSorted[index].score ? `${sportMatchesSorted[index].score.home}:${sportMatchesSorted[index].score.away} ` : ''}}{{sportMatchesSorted[index].status}}{{sportMatchesSorted[index].time ? ` / ${sportMatchesSorted[index].time}'` : null}}
            {{!sportMatchesSorted[index].status && !sportMatchesSorted[index].time ? '-- / --' : null}}
          </span>
        </a>
      </span>
      <favorite-component :match="sportMatchesSorted[index]" :isFixture="true"/>
      </li>
    </ul>
  </li>
</template>

<script>
  import FavoriteComponent from '../../shared/favorite-component';

  export default {
    name: 'LiveFixtureItemComponent',
    components: {
      FavoriteComponent,
    },
    props: {
      sportMatchesSorted: {
        type: Array,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
      matchSelectedId: {
        required: true,
      },
      liveMatchClick: {
        type: Function,
        required: true,
      },
    },
  };
</script>
